module.exports = __webpack_public_path__ + "static/media/Video_MDM.de999d7b.gif";